module.exports = __webpack_public_path__ + "static/media/7.818d483a.jpg";